import { LogIn, ShieldCheck } from 'lucide-react';
import { LOGO_URL } from '../constants';

export default function LoginGate({ error }) {
  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/admin';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 sm:p-10 max-w-md w-full text-center" data-testid="login-gate">
        <img src={LOGO_URL} alt="Pniel Analytics" width="320" height="152" className="h-12 w-auto mx-auto mb-6" />
        <div className="w-14 h-14 rounded-full bg-[#003A70]/10 flex items-center justify-center mx-auto mb-4">
          <ShieldCheck className="w-7 h-7 text-[#003A70]" />
        </div>
        <h1 className="text-xl font-bold text-[#003A70] font-heading mb-2">Admin Access</h1>
        <p className="text-gray-500 text-sm mb-6">Sign in with your authorized Google account to manage testimonials and leads.</p>
        {error && (
          <div data-testid="login-error" className="mb-5 text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg px-4 py-3">{error}</div>
        )}
        <button data-testid="google-login-btn" onClick={handleLogin}
          className="w-full flex items-center justify-center gap-2 px-5 py-3 bg-[#003A70] hover:bg-[#1e40af] text-white font-semibold rounded-lg transition-colors">
          <LogIn className="w-4 h-4" /> Sign in with Google
        </button>
        <a href="/" className="inline-block mt-5 text-xs text-gray-400 hover:text-gray-600">← Back to website</a>
      </div>
    </div>
  );
}
